import { DropdownListItem } from '@design/components/dropdown/dropdown-list-item/DropdownListItem';
import { Icon } from '@design/components/icon/Icon';
import { ListEntityItem } from '@terminal/components/search-modal/components/list-entity-item/ListEntityItem';
import { ListThemeItem } from '@terminal/components/search-modal/components/list-theme-item/ListThemeItem';
import { ListTitleItem } from '@terminal/components/search-modal/components/list-title-item/ListTitleItem';

import { MentionCandidate } from '../types';

export interface MentionPopupSection {
  label: string;
  items: MentionCandidate[];
}

export interface MentionSectionTitleRow {
  title: string;
  disabled: true;
}

export type MentionDropdownItem = MentionSectionTitleRow | MentionCandidate;

export const isMentionSectionTitleRow = (
  item: MentionDropdownItem | undefined
): item is MentionSectionTitleRow => !!item && 'title' in item;

export const flattenMentionSections = (
  sections: MentionPopupSection[]
): MentionDropdownItem[] =>
  sections.flatMap(section =>
    section.items.length === 0
      ? []
      : [{ title: section.label, disabled: true as const }, ...section.items]
  );

export interface MentionPopupRowProps {
  item: MentionDropdownItem;
  isFocused: boolean;
  searchQuery: string;
}

export const MentionPopupRow = ({
  item,
  isFocused,
  searchQuery,
}: MentionPopupRowProps) => {
  if (isMentionSectionTitleRow(item)) {
    return <ListTitleItem item={{ title: item.title }} variant="secondary" />;
  }

  if (item.kind === 'entity') {
    return (
      <ListEntityItem
        entity={item.entity}
        isFocused={isFocused}
        highlighted={searchQuery}
      />
    );
  }

  if (item.kind === 'theme') {
    return (
      <ListThemeItem
        theme={item.theme}
        isFocused={isFocused}
        highlighted={searchQuery}
      />
    );
  }

  return (
    <DropdownListItem
      label={item.label}
      leadingIcon={<Icon iconName="Watchlist" size={16} />}
      isActive={false}
      isFocused={isFocused}
    />
  );
};
